import { Typography } from "../../atoms/typography";
import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import { useCardContext } from "./card-context";
import { cardDescriptionColor, cardTitleColor } from "./lib";
import type { CardDescriptionProps, CardHeaderProps, CardTitleProps } from "./types";

export const CardHeader = ({ className, testID, children }: CardHeaderProps) => (
  <Box
    className={cn("gap-spacing-xs flex flex-1 flex-col justify-center", className)}
    {...platformProps({ testID, slot: "card-header" })}
  >
    {children}
  </Box>
);

CardHeader.displayName = "Card.Header";

export const CardTitle = ({ className, testID, children }: CardTitleProps) => {
  const { state } = useCardContext();

  return (
    <Typography
      variant="label-sm"
      color={cardTitleColor[state]}
      className={className}
      {...platformProps({ testID, slot: "card-title" })}
    >
      {children}
    </Typography>
  );
};

CardTitle.displayName = "Card.Title";

export const CardDescription = ({ className, testID, children }: CardDescriptionProps) => {
  const { state } = useCardContext();

  return (
    <Typography
      variant="body-sm"
      color={cardDescriptionColor[state]}
      className={className}
      {...platformProps({ testID, slot: "card-description" })}
    >
      {children}
    </Typography>
  );
};

CardDescription.displayName = "Card.Description";
